// extracted by mini-css-extract-plugin
module.exports = {"wrap":"da51a739f7--wrap--zQ75m","tabs":"da51a739f7--tabs--Wdhvj","wrap-left-blur":"da51a739f7--wrap-left-blur--rD4kQ","wrap-right-blur":"da51a739f7--wrap-right-blur--gI_XY"};